import BaseApi from "../../api/api"

export const getWbSamsonLogData = () => {
  return BaseApi.logForSamsonWb().then((res) => {
    if (res.success) return res.data
    return []
  })
}

export const getYaSamsonLogData = () => {
  return BaseApi.logForSamsonYa().then((res) => {
    if (res.success) return res.data
    return []
  })
}
